import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import TopBar from '@/components/TopBar';
import { CardSm, Pill } from '@/components/ui/Form';
import { Button } from '@/components/ui/Button';
import { TreeStructure, Plus } from '@phosphor-icons/react';
import { healthClassToColor } from '@/lib/utils';

export default function Inspect() {
  const [trees, setTrees] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    api.get('/trees').then((r) => setTrees(r.data));
  }, []);

  const filtered = trees.filter((t) =>
    !filter || (t.tree_code || '').toLowerCase().includes(filter.toLowerCase()) ||
    (t.species_scientific || '').toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div data-testid="inspect-page">
      <TopBar title="Inspect Trees" />
      <div className="p-4 space-y-3">
        <Button as={Link} to="/trees/new" className="w-full" variant="dark" data-testid="inspect-new-tree-btn">
          <Plus size={20} weight="bold" /> Register new tree
        </Button>
        <input
          type="text"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Filter by code or species…"
          className="input-rugged font-sans"
          data-testid="tree-filter"
        />

        {filtered.length === 0 ? (
          <CardSm>
            <p className="text-sm text-carbon-soft">No trees yet. Register your first tree.</p>
          </CardSm>
        ) : (
          <ul className="space-y-2" data-testid="tree-list">
            {filtered.map((t) => (
              <li key={t.id}>
                <Link to={`/trees/${t.id}`} className="card-hard-sm p-3 flex items-center gap-3 hover:bg-surface-alt" data-testid={`tree-${t.id}`}>
                  <TreeStructure size={26} weight="bold" />
                  <div className="flex-1 min-w-0">
                    <p className="font-display font-bold text-sm truncate">{t.tree_code || t.id.slice(0, 8)}</p>
                    <p className="text-xs mono text-carbon-soft truncate">
                      {t.species_scientific || 'unidentified'}
                    </p>
                  </div>
                  {t.latest_health_class && (
                    <Pill color={healthClassToColor(t.latest_health_class)}>
                      {t.latest_health_class}
                    </Pill>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
